import store from "@/store";
const directorAuth = (to, from, next) => {
  if (!store.getters.isDirectorAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.

    alert("로그인이 필요합니다");

    next("/director/loginDo");
  } else {
    next();
  }
};
const funeralAuth = (to, from, next) => {
  if (!store.getters.isFuneralAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/funeral/loginDo");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Tablet1"
    },
    path: "/tablet1",
    name: "Tablet1",

    component: () => import("@/views/tablet/Tablet1.vue")
  },

  {
    meta: {
      title: "Tablet2"
    },
    path: "/tablet2",
    name: "Tablet2",

    component: () => import("@/views/tablet/Tablet2.vue")
  },

  {
    meta: {
      title: "Tablet3"
    },
    path: "/tablet3",
    name: "Tablet3",

    component: () => import("@/views/tablet/Tablet3.vue")
  },
  {
    meta: {
      title: "Tablet1"
    },
    path: "/director/tablet1",
    name: "Tablet1",
    beforeEnter: directorAuth,
    component: () => import("@/views/tablet/Tablet1.vue")
  },

  {
    meta: {
      title: "Tablet2"
    },
    path: "/director/tablet2",
    name: "Tablet2",
    beforeEnter: directorAuth,
    component: () => import("@/views/tablet/Tablet2.vue")
  },

  {
    meta: {
      title: "Tablet3"
    },
    path: "/director/tablet3",
    name: "Tablet3",
    beforeEnter: directorAuth,
    component: () => import("@/views/tablet/Tablet3.vue")
  },

  {
    meta: {
      title: "Tablet1"
    },
    path: "/funeral/tablet1",
    name: "Tablet1",
    beforeEnter: funeralAuth,
    component: () => import("@/views/tablet/Tablet1.vue")
  },

  {
    meta: {
      title: "Tablet2"
    },
    path: "/funeral/tablet2",
    name: "Tablet2",
    beforeEnter: funeralAuth,
    component: () => import("@/views/tablet/Tablet2.vue")
  },

  {
    meta: {
      title: "Tablet3"
    },
    path: "/funeral/tablet3",
    name: "Tablet3",
    beforeEnter: funeralAuth,
    component: () => import("@/views/tablet/Tablet3.vue")
  }
];
